import React from 'react';
import { ViewingDate } from '../components/ViewingDate';

const getRoleType = (data) => {
  if (data.is_owner) return 'owner';
  return 'applicant';
};

const propertyAddress = (data) => {
  if (data?.display_address) return data?.display_address;

  if (data?.property_address) {
    const address = data.property_address;
    if (address) {
      let display_address = [address.buildingNumber, address.line1, address.postcode];
      display_address = display_address.filter((n) => n); // remove empty https://stackoverflow.com/questions/281264/remove-empty-elements-from-an-array-in-javascript
      display_address = display_address.join(', ');
      return `for ${display_address}`;
    }
  }
  return '';
};

const propertyShortAddress = (address) => {
  let display_address = [address.buildingNumber, address.line1, address.postcode];
  display_address = display_address.filter((n) => n); // remove empty https://stackoverflow.com/questions/281264/remove-empty-elements-from-an-array-in-javascript
  return display_address.join(', ');
};

const formatPrice = (price) => {
  return new Intl.NumberFormat('en', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);
};

const ActionTitle = ({ data, withDate = false, ...rest }) => {
  const action = (data.action || '').trim();

  const display_address = propertyAddress(data);

  let title = action;
  let type = '';
  let text = '';

  switch (action) {
    case 'Viewing':
      let presentText = 'have';
      if (data.completed) presentText = 'had';

      let name = 'You'; // Applicant
      if (data.is_owner) name = data.applicant_name;

      title = (
        <>
          {`${name} ${presentText} viewing`}
          {withDate && (
            <>
              {' on'}
              <ViewingDate timestamp={data.value} />
            </>
          )}
        </>
      );

      break;
    case 'viewing_pending':
    case 'pending_viewing':
      title = (
        <>
          {`Upcoming Viewing ${display_address}`}{' '}
          {withDate && (
            <>
              {' on'}
              <ViewingDate timestamp={data.value} />
            </>
          )}
        </>
      );

      break;
    case 'viewing_created': // viewing requested
      title = (
        <>
          {`Viewing requested ${display_address}`}{' '}
          {withDate && (
            <>
              {' on'}
              <ViewingDate timestamp={data.value} />
            </>
          )}
        </>
      );

      break;
    case 'viewing_confirmed':
      title = (
        <>
          {`Viewing confirmed ${display_address}`}{' '}
          {withDate && (
            <>
              {' on'}
              <ViewingDate timestamp={data.value} />
            </>
          )}
        </>
      );
      break;

    case 'viewing_cancelled':
      title = (
        <>
          {`Viewing cancelled ${display_address}`}{' '}
          {withDate && (
            <>
              {' on'}
              <ViewingDate timestamp={data.value} />
            </>
          )}
        </>
      );
      break;
    case 'pending_valuation':
      title = (
        <>
          {`Upcoming Valuation ${display_address} on `}{' '}
          {withDate && (
            <>
              {' on'}
              <ViewingDate timestamp={data.value} />
            </>
          )}
        </>
      );
      break;
    case 'offer':
      // 'Offer of XXX posted - Status'
      console.log('data of => ', data);
      type = '';
      if (data.is_owner) {
        title = `Offer of ${formatPrice(data.value)} received ${display_address} from ${
          data.applicant_name
        } - ${data.offer_status}`;
      } else {
        title = `Offer of ${formatPrice(data.value)} posted ${display_address} - ${
          data.offer_status
        }`;
      }

      break;
    case 'offer_created': // offer received
      // case "tenancy_created":

      type = '';
      if (data.is_owner) {
        type = 'received';
      } else {
        type = 'posted';
      }
      title = `Offer of ${formatPrice(data.value)} ${type} ${display_address} `;

      break;
    case 'tenancy_created':
      type = '';
      if (data.is_owner) {
        type = 'received';
      } else {
        type = 'posted';
      }
      title = `Tenancy of ${formatPrice(data.value)} ${type} ${display_address} `;

      break;
    case 'offer_accepted':
      title = `Offer of ${formatPrice(data.value)} accepted ${display_address} `;
      break;
    case 'tenancy_pending':
      title = `Tenancy of ${data.rent_frequency} ${formatPrice(
        data.value
      )} pending ${display_address} `;
      break;
    case 'tenancy_arranging':
      type = '';
      if (data.is_owner) {
        type = 'you have accepted';
      } else {
        type = 'has been accepted';
      }
      title = `Tenancy of ${formatPrice(data.value)} ${type} ${display_address} `;
      break;
    case 'tenancy_rejected':
      type = '';
      if (data.is_owner) {
        type = 'you have rejected';
      } else {
        type = 'has been rejected';
      }
      title = `Tenancy of ${formatPrice(data.value)} ${type} ${display_address} `;
      break;
    case 'tenancy_withdrawn':
      type = '';
      if (data.is_owner) {
        type = 'has beed withdrawn';
      } else {
        type = 'you have withdrawn';
      }
      title = `Tenancy of ${formatPrice(data.value)} ${type} ${display_address} `;
      break;
    case 'offer_pending':
      title = `Offer of ${formatPrice(data.value)} pending ${display_address} `;
      break;
    case 'offer_revised':
      title = `Offer of ${formatPrice(data.value)} revised ${display_address} `;
      break;
    case 'offer_rejected':
      title = `Offer of ${formatPrice(data.value)} rejected ${display_address} `;
      break;
    case 'offer_withdrawn':
      title = `Offer of ${formatPrice(data.value)} withdrawn ${display_address} `;
      break;

    case 'feedback_received':
      text = '';
      if (!display_address) text = 'for';
      if (data.is_owner) {
        title = (
          <>
            {`Feedback received from ${data.applicant_name} ${text} ${display_address} viewing on `}
            {withDate && (
              <>
                {' on'}
                <ViewingDate timestamp={data.appointment_date} />
              </>
            )}
          </>
        );
      } else {
        title = (
          <>
            {`Feedback posted ${text} ${display_address} viewing on `}
            {withDate && (
              <>
                {' on'}
                <ViewingDate timestamp={data.appointment_date} />
              </>
            )}
          </>
        );
      }

      break;
    case 'feedback_pending':
      text = '';
      if (!display_address) text = 'for';
      title = (
        <>
          {`Feedback pending ${text} ${display_address} viewing on`}{' '}
          {withDate && (
            <>
              {' on'}
              <ViewingDate timestamp={data.value} />
            </>
          )}
        </>
      );
      break;
    case 'Feedback':
      title = `Feedback - ${data.value} ${display_address} - ${data.applicant_name}`;
      break;
    case 'Market Appraisal':
      title = (
        <>
          {`Market Appraisal `} {' on '}
          {withDate && (
            <>
              {' on'}
              <ViewingDate timestamp={data.value} />
            </>
          )}
        </>
      );
      break;
    default:
      title = action;
  }

  // title = data.id

  return <>{title}</>;
};

export { ActionTitle, propertyShortAddress, formatPrice, getRoleType };
